export default {
	'concept': {
		'text': `<div class="content-caption-box">
				<h3 class="content-caption">The Minto Pyramid Principle® Concept</h3>
			</div>
			<p class="content-text">The Minto Pyramid Principle is a technique to help you work out and organize your thinking before you attempt to communicate
				it.
			</p>
			<p class="content-text">It states that a clear piece of writing will always consist of groups of related ideas, each group summarized to form
				the next level of a pyramid, rising to a single pyramid with a single point at the top. And that the relationships between
				ideas at every level within that pyramid, both vertically and horizontally, will obey a set of strict logical rules.</p>
			<p class="content-text">Before you begin to write, therefore, you want to force your ideas to fit that pyramid form, and make sure they obey the
				logical rules. Communicating your thinking then requires only that you guide your reader down the pyramid.</p>
			<p class="content-text">So far, so clear. The hard part is forcing your thinking to fit the pyramid form, particularly given that you rarely know
				precisely what all your ideas are before you attempt to arrange them into related groupings. So the thinking process
				consists of pulling the ideas out of your head and fitting them together in a pyramid.</p>
			<p class="content-text">The genius of the Minto Pyramid Principle is that it helps you work efficiently both to formulate the ideas and to organize
				them at the same time. Thus avoiding the need to write countless drafts before you settle on your message.</p>`
	}
}


// WEBPACK FOOTER //
// ./client/app/modules/site/concept/i18n/en.js